import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import TwelveWeekChallenge from "./pages/TwelveWeekChallenge/TwelveWeekChallenge";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import ThankYou from "./pages/Thankyou/Thankyou";

const App: React.FC = () => {
  return (
    <Router>
      <CookieBanner />
      <Routes>
        <Route path="/" element={<TwelveWeekChallenge />} />
        <Route path="/home" element={<Home />} />
        <Route path="/12-week-challenge" element={<TwelveWeekChallenge />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </Router>
  );
};

export default App;
